import { Component, ViewChild } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { AdminHeaderButton } from "@interfaces/adminHeaderButton.interface";
import { Group } from "@interfaces/group.interface";
import { ProtectedGrid } from "@interfaces/protectedGrid.interface";
import { ProtectedGridGroup } from "@interfaces/protectedGridGroup.interface";
import { GroupService } from "@services/group.service";
import { ProtectedGridService } from "@services/protectedGrid.service";
import { ToastService } from "angular-toastify";
import { DxDataGridComponent } from "devextreme-angular";

@Component({
	moduleId: module.id,
	selector: "protectedGrids-id",
	styleUrls: ["protectedGrids-id.css"],
	templateUrl: "protectedGrids-id.html"
})
export class ProtectedGridsIdAdminComponent {
	@ViewChild("groupsGridContainer", { static: false }) consumablesGrid!: DxDataGridComponent;
	changes: any = [];
	editRowKey: any = null;
	groups: Group[] = [];
	headerPrimaryButtons: AdminHeaderButton[] = [];
	headerTertiaryButtons: AdminHeaderButton[] = [];
	item: ProtectedGrid = new ProtectedGrid();
	itemId = 0;
	itemType = "Protected Grid";
	readOnly = true;
	returnUrl: string = location.href.split("/")[3] + "/" + location.href.split("/")[4];
	selectedGroups: ProtectedGridGroup[] = [];
	title: string = "View " + this.itemType;

	constructor(private router: Router, private toastService: ToastService, private route: ActivatedRoute, private itemService: ProtectedGridService, private groupService: GroupService) {
		this.getGroups();
		this.route.params
			.subscribe((params) => {
				if (params.id != "create") {
					if (params.id.split("_").length > 1) {
						this.getItem(params.id.split("_")[0]);
						this.edit();
					} else {
						this.getItem(params.id);
						this.buildButtons("view");
					}
				} else {
					this.create();
				}
			});
	}

	buildButtons(mode: string) {
		if (mode == "edit") {
			this.headerPrimaryButtons = [
				{ method: "updateItem", text: "Save Changes" },
				{ method: "cancelEditing", text: "View Mode" },
				{ method: "close", text: "Close" }
			];
		} else if (mode == "create") {
			this.headerPrimaryButtons = [
				{ method: "createItem", text: "Save" },
				{ method: "close", text: "Close" }
			];
			this.headerTertiaryButtons = [];
		} else if (mode == "view") {
			this.headerPrimaryButtons = [
				{ method: "edit", text: "Edit" },
				{ method: "close", text: "Close" }
			];
		}
	}

	cancelEditing() {
		if (confirm("Are you sure you wish to switch modes? Unsaved changes will be discarded.") == false) {
			return;
		}
		this.readOnly = true;
		this.buildButtons("view");
		this.title = "View " + this.itemType;
	}

	close() {
		this.router.navigate([`/${this.returnUrl}/`]);
	}

	create() {
		this.readOnly = false;
		this.buildButtons("create");
		this.title = "Create New " + this.itemType;
	}

	createItem() {
		this.item.groups = JSON.stringify(this.selectedGroups);
		this.itemService.createSingle(this.item)
			.subscribe(
				() => {
					this.toastService.success("Successfully Updated " + this.itemType);
					this.close();
				},
				(err) => {
					console.log(err);
					this.toastService.error("Something Went Wrong!");
				}
			);
	}

	edit() {
		this.readOnly = false;
		this.buildButtons("edit");
		this.title = "Edit " + this.itemType;
		this.toastService.warn("You are now editing...");
	}

	getGroups() {
		this.groupService.getAll()
			.subscribe(
				(res: any) => this.groups = res.response.items,
				(err) => console.log(err)
			);
	}

	getItem(itemId: number) {
		this.itemService.getSingleById(itemId)
			.subscribe(
				(res: any) => {
					this.item = res.response;
					this.selectedGroups = JSON.parse(this.item.groups);
				},
				(err) => {console.log(err); this.toastService.error("Something Went Wrong!");}
			);
	}

	headerButtonClick(method: any) {
		// @ts-ignore // Required to be able to call the method directly from the variable
		if (this[method]) this[method]();
	}

	updateItem() {
		this.item.groups = JSON.stringify(this.selectedGroups);
		this.itemService.updateSingleById(this.item.id, this.item)
			.subscribe(
				() => {this.toastService.success("Successfully Updated");},
				(err) => {
					console.log(err);
					this.toastService.error("Something Went Wrong!");
				}
			);
	}
}